import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { isNullOrUndefined, PEV } from "../../common/utils";
import {
  getUserGroupsList,
  getUserGroupsListExtraReducers,
  userGroupListTabStateManagement,
} from "./listUserGroups/model";
import * as service from "./service";
import {
  getUserGroupDetails,
  getUserGroupDetailsExtraReducers,
  userGroupDetailsTabStateManagement,
} from "./userGroupDetails/model";
import {
  loadUserGroupDetailsTabsMetaData,
  loadUserGroupListTabsMetaData,
} from "./userGroupLocalStorage";

const initialState = {
  types: PEV({}, "Not Loaded"),
  userGroupList: {},
  userGroupListTabStates: loadUserGroupListTabsMetaData(),
  userGroupDetailsTabStates: loadUserGroupDetailsTabsMetaData(),
  userGroupDetails: {},
  userGroupScopeList: PEV([], "Not loaded"),
};

const getUserGroupTypes = createAsyncThunk("userGroupType/get", async () => {
  return await service.getUserGroupTypes();
});

export const getAllUserGroupScope = createAsyncThunk("userGroupScope/get", async () => {
  return await service.getAllUserGroupScope();
});

const UserGroupSlice = createSlice({
  name: "user-groups",
  initialState,
  reducers: {
    setPublishedStatusForUserGroup(state, action){
      let {userGroupId, userGroupTypeId} = action.payload;
      const index = state.userGroupList[userGroupTypeId].value.userGroupList.findIndex( (userGroup) => {
       return userGroup.id === userGroupId
      })
      state.userGroupList[userGroupTypeId].value.userGroupList[index].isPublished = true
      state.userGroupList[userGroupTypeId].value.userGroupList[index].isAllowedToPublish = false;
    },
    setActiveTab(state, action) {
      let { userGroupTypeId, userGroupId, activeTab } = action.payload;
      if (!isNullOrUndefined(userGroupTypeId)) {
        userGroupListTabStateManagement(state, userGroupTypeId, activeTab);
      } else if (!isNullOrUndefined(userGroupId)) {
        userGroupDetailsTabStateManagement(state, userGroupId, activeTab);
      }
    },
    resetUserGroupData(state) {
      state.types = initialState.types;
      state.userGroupList = initialState.userGroupList;
      state.userGroupListTabStates = loadUserGroupListTabsMetaData();
      state.userGroupDetailsTabStates = loadUserGroupDetailsTabsMetaData();
      state.userGroupDetails = {};
    },
    setUnSelectedColumns(state, action) {
      let { userGroupId, tabName, unSelectedColumns } = action.payload;
      if (!(userGroupId in state.userGroupDetailsTabStates)) {
        state.userGroupDetailsTabStates[userGroupId] = {};
      }
      state.userGroupDetailsTabStates[userGroupId][tabName] = {
        ...state.userGroupDetailsTabStates[userGroupId][tabName],
        unSelectedColumns: unSelectedColumns,
      };
    },
    setTabPageSize(state, action) {
      let { tabName, userGroupId, pageSize } = action.payload;
      if (!(userGroupId in state.userGroupDetailsTabStates)) {
        state.userGroupDetailsTabStates[userGroupId] = {};
      }
      state.userGroupDetailsTabStates[userGroupId][tabName] = {
        ...state.userGroupDetailsTabStates[userGroupId][tabName],
        pageSize,
      };
    },
  },
  extraReducers: {
    [getUserGroupTypes.pending.type]: (state) => {
      state.types = PEV({ ...state.types.value }, "Fetching user group types");
    },
    [getUserGroupTypes.fulfilled.type]: (state, action) => {
      let arrayData = action.payload;
      let userGroupTypes = {};
      arrayData.forEach((type) => {
        const id = type.id;
        userGroupTypes[id] = type;
      });
      state.types = PEV(userGroupTypes);
    },
    [getUserGroupTypes.rejected.type]: (state) => {
      state.types = PEV({ ...state.types }, null, "Error while fetching user group types");
    },
    [getAllUserGroupScope.pending.type]: (state) => {
      state.userGroupScopeList = PEV([], "Fetching all user group scope");
    },
    [getAllUserGroupScope.fulfilled.type]: (state, action) => {
      state.userGroupScopeList = PEV(action.payload);
    },
    [getAllUserGroupScope.rejected.type]: (state) => {
      state.userGroupScopeList = PEV([], null, "Error while fetching user group scope");
    },
    ...getUserGroupsListExtraReducers,
    ...getUserGroupDetailsExtraReducers,
  },
});

const { setActiveTab, resetUserGroupData, setUnSelectedColumns, setTabPageSize, setPublishedStatusForUserGroup } =
  UserGroupSlice.actions;
export const UserGroupActions = {
  getUserGroupTypes,
  setActiveTab,
  resetUserGroupData,
  getUserGroupsList,
  getUserGroupDetails,
  setUnSelectedColumns,
  setTabPageSize,
  getAllUserGroupScope,
  setPublishedStatusForUserGroup
};

export const UserGroupReducer = UserGroupSlice.reducer;
